export default __webpack_public_path__ + "static/media/Path 100.6cbe0fb3.svg";